import { Box, Grid, Link, Typography } from "@mui/material"
import { useAppSelector } from "../../lib/hook";
import { indexSelector, SearchResult } from "../../lib/ducks/indexDuck";
import { Fragment } from "react";

interface searchResultElementProps {
    result: string
}

const SearchResultElement: React.FC<searchResultElementProps> = ({ result }) => (
    <Box>
            <Typography
                sx={{
                    display: '-webkit-box',
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 1,
                }}
                variant="body1">
                {result}
            </Typography>
    </Box>

)

export const ListResult = () => {
    const results = useAppSelector(indexSelector).search;

    return (
        <>
            {
            <Grid container marginTop={2} spacing={2} paddingRight={1}>
                <Grid item xs={10}>
                    Tiedostonimi
                </Grid>

                <Grid item xs={2}>
                    #
                </Grid>

            </Grid>
            }
            <Box overflow={'auto'} marginTop={2}>
                <Grid container spacing={2}>
                    {results?.titles?.map((title: string, index: number) => (
                        <Fragment key={"result" + index}>
                            <Grid item xs={10}>
                                <SearchResultElement result={title} />
                            </Grid>
                            <Grid item xs={2}>
                                <Box display={'flex'} alignContent={'center'}>
                                    <Typography>
                                        {index}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Fragment>
                    ))}
                </Grid>
            </Box>
        </>
    )
}
